// Shared by BalanceForecastChart and PurchaseForecastChart — both bar
// charts pick their y-axis max/step count the same way (round the peak
// value up to a "nice" step so gridlines land on round numbers). Extracted
// out of both (byte-identical duplication, Sonar-flagged) rather than kept
// as two copies.
const AXIS_STEPS = [50_000, 100_000, 250_000, 500_000, 1_000_000, 2_500_000, 5_000_000, 10_000_000]

export function axisScale(peak: number): { max: number; steps: number } {
  const step = AXIS_STEPS.find((st) => peak / st <= 4) ?? AXIS_STEPS[AXIS_STEPS.length - 1]
  const max = Math.ceil(peak / step) * step
  return { max, steps: Math.max(1, Math.round(max / step)) }
}
